import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/**
 * Mutation hook for restoring an archived member. Any patients that were
 * cascaded during the original archive are also restored server-side; same
 * invalidation set as `useArchiveMember`.
 */
export function useUnarchiveMember(memberId: string) {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => {
      const response = await api.delete('/members/:memberId/archive', { params: { memberId } })
      if (!response.success) throw new Error(response.error.message)
      return response.data.member
    },
    onSuccess: (member) => {
      queryClient.invalidateQueries({ queryKey: ['member', memberId] })
      queryClient.invalidateQueries({ queryKey: ['members'] })
      queryClient.invalidateQueries({ queryKey: ['patients'] })
      for (const pet of member.pets) {
        queryClient.invalidateQueries({ queryKey: ['patient', pet.id] })
      }
    },
  })
}
